import React from "react";
import { Helmet } from "react-helmet-async";
import { BUSINESS_INFO } from "../data";

export default function SeoHead({ title, description, path = "" }) {
  const fullTitle = path === "/" || !title ? BUSINESS_INFO.name : `${title} - ${BUSINESS_INFO.name}`;
  const defaultDesc = "Ses Multi Service tilbyder grundig rengøring af sommerhuse og Airbnb i Norddjurs samt klip og vask af hunde under 10 kg. Kontakt os for en forespørgsel.";
  const metaDesc = description || defaultDesc;
  const canonicalUrl = `https://sesmultiservice.dk${path}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={metaDesc} />
      <link rel="canonical" href={canonicalUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={metaDesc} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:site_name" content={BUSINESS_INFO.name} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={metaDesc} />
    </Helmet>
  );
}
